export default "__VITE_ASSET__BSZhA8wC__"